module.exports = __webpack_public_path__ + "static/img/wisdom2.d53a6911.png";